import PropTypes from 'prop-types';
import { Stack, Button, Text, Group, Box } from '@mantine/core';
import { colors, fontSize } from '../constants';
import { useAppContext, SET_HOUSE_SIZE } from '../context/AppContext';

const HouseSizeMobile = ({ selectedHouseSize, onSizeClick }) => {
	const { dispatch } = useAppContext();

	const handleSizeChoice = (houseSizeId) => {
		console.log('HouseSizeMobile received click on', houseSizeId);
		dispatch({ type: SET_HOUSE_SIZE, payload: houseSizeId });
		onSizeClick(houseSizeId);
	};

	return (
		<Box style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
			<Stack gap="15px" align="center" style={{ width: '100%' }}>
				<Text style={{
					color: colors.white,
					fontSize: fontSize.xl,
					fontWeight: 'bold',
					textAlign: 'center',
					marginTop: '15px',
					marginBottom: '0px'
				}}>
					House Size
				</Text>
				
				<Group justify="center" gap="5px" style={{ width: '100%' }}>
					<Button
						variant="filled"
						onClick={() => handleSizeChoice(12)}
						styles={{
							root: {
								backgroundColor: selectedHouseSize === 12 ? colors.buttonGreen : colors.buttonColor,
								borderRadius: '12px',
								height: 80,
								width: 80,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								padding: 0
							}
						}}
					>
						<Text style={{
							color: colors.black,
							fontSize: fontSize.xl,
						}}>
							12&apos;
						</Text>
					</Button>
					
					<Button
						variant="filled"
						onClick={() => handleSizeChoice(15)}
						styles={{
							root: {
								backgroundColor: selectedHouseSize === 15 ? colors.buttonGreen : colors.buttonColor,
								borderRadius: '12px',
								height: 80,
								width: 80,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								padding: 0
							}
						}}
					>
						<Text style={{
							color: colors.black,
							fontSize: fontSize.xl,
						}}>
							15&apos;
						</Text>
					</Button>
					
					<Button
						variant="filled"
						onClick={() => handleSizeChoice(18)}
						styles={{
							root: {
								backgroundColor: selectedHouseSize === 18 ? colors.buttonGreen : colors.buttonColor,
								borderRadius: '12px',
								height: 80,
								width: 80,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								padding: 0
							}
						}}
					>
						<Text style={{
							color: colors.black,
							fontSize: fontSize.xl,
						}}>
							18&apos;
						</Text>
					</Button>
				</Group>
			</Stack>
		</Box>
	);
};

HouseSizeMobile.propTypes = {
	selectedHouseSize: PropTypes.number,
	onSizeClick: PropTypes.func.isRequired
};

export default HouseSizeMobile;
